import { embed } from '../Helper/iFrame';

embed('vimeo');
